import React from 'react';
type SectionHeadingProps = {
  title: string;
  text?: string;
  as?: 'h1' | 'h2';
  align?: 'center' | 'left';
};
export function SectionHeading({
  title,
  text,
  as = 'h2',
  align = 'center'
}: SectionHeadingProps) {
  const Tag = as;
  return <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-203" data-mp="3f2wwpkj9gxw6">
      <Tag className="font-slab text-3xl font-bold uppercase tracking-[0.15em] md:text-4xl" data-id="element-204" data-mp="3k0oxz55spwd1">{title}</Tag>
      {text && <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-205" data-mp="bmgeqnp5yhxj">{text}</p>}
    </div>;
}